import React, { Fragment } from 'react';
import {
    Skeleton,
    styled,
    Table,
    TableBody,
    TableRow,
    TableCell,
} from '@mui/material';

import { GraphDataPoint } from '../../interfaces/graphInterfaces';
import { ValueReferences } from '../../utils/enums';
import { formatNumber } from '../../utils/formattingUtils';

const classesPrefix = 'transitLegend';

const classes = {
    table: `${classesPrefix}-table`,
    centered: `${classesPrefix}-centered`,
    colorSwatch: `${classesPrefix}-colorSwatch`,
    rightTableCol: `${classesPrefix}-rightTableCol`,
};

const StyledTable = styled(Table)(({ theme }) => {
    return {
        [`&.${classes.table}`]: {
            '& td': {
                borderBottom: 'none',
                paddingLeft: 0,
                paddingRight: 0,
                paddingBottom: 0,
            },
        },
        [`& .${classes.centered}`]: {
            display: 'flex',
            alignItems: 'center',
        },
        [`& .${classes.colorSwatch}`]: {
            height: theme.spacing(2),
            width: theme.spacing(2),
            borderRadius: 2,
            display: 'inline-flex',
            marginRight: theme.spacing(1),
        },
        [`& .${classes.rightTableCol}`]: {
            textAlign: 'right',
            paddingLeft: `${theme.spacing(3)} !important`,
        },
    };
});

const TransitLegend = ({
    loading,
    data,
    colors,
}: {
    loading: boolean;
    data: GraphDataPoint[];
    colors: React.CSSProperties['color'][];
}): React.JSX.Element => {
    const renderTableValue = (item: GraphDataPoint): React.JSX.Element => {
        if (loading) {
            return <Skeleton />;
        }

        if (item.value === null) {
            return <strong>{ValueReferences.NA}</strong>;
        }

        return (
            <Fragment>
                <strong>{formatNumber(item.value, 2, 2)}</strong>
                <span> hours/order</span>
            </Fragment>
        );
    };

    return (
        <StyledTable size='small' className={classes.table}>
            <TableBody>
                {
                    data.map((item, index) => {
                        return (
                            <TableRow key={`transit-graph-key-row=${index}`}>
                                <TableCell className={classes.centered}>
                                    <div
                                        className={classes.colorSwatch}
                                        style={{
                                            backgroundColor: colors[index],
                                        }}
                                    />
                                    {item.name}
                                </TableCell>
                                <TableCell className={classes.rightTableCol}>
                                    {renderTableValue(item)}
                                </TableCell>
                            </TableRow>
                        );
                    })
                }
            </TableBody>
        </StyledTable>
    );
};

export default TransitLegend;
